<template>
  <v-container fluid class="custom-container">

    <!-- Folders Header -->
    <v-layout
      justify-space-between
      align-center
      v-if="!isEmpty(groupedFolders)"
      class="list-folders-actions pb-2"
    >
      <pending-cards :folders="folders"/>
    </v-layout>

    <!-- Folders List -->
    <section class="folders" v-if="!isEmpty(groupedFolders)">
      <v-layout
        class="folder-list"
        v-for="(group,index) in groupedFolders"
        :key="index"
        column
      >
        <strong
          class="grey--text mt-3 mb-3 text-capitalize"
        >
          {{ index }}
        </strong>
        <pending-items-table
          v-if="group.length > 0"
          :items="group"
        />
      </v-layout>
    </section>

    <!-- Empty Content -->
    <v-container fill-height v-if="isEmpty(groupedFolders) && !loading.show">
      <v-layout column align-center justify-center>
        <v-icon class="mb-2" size="48" color="grey darken-2">mdi-clock-alert-outline</v-icon>
        <span class="title font-weight-regular grey--text text--darken-2">
          Não há itens para exibir
        </span>
      </v-layout>
    </v-container>

  </v-container>
</template>


<script>
import { capitalize, startCase, lowerCase, truncate, isEmpty } from 'lodash';
import acronym from '@/utils/acronym';
import format from 'date-fns/format';
import shortName from '@/utils/short-name';
import * as ptLocale from 'date-fns/locale/pt';
import colors from 'vuetify/es5/util/colors';

import PendingItemsTable from '@/components/base/PendingItemsTable';
import PendingCards from './PendingCards';


export default {
  name: 'pending',
  components: {
    PendingCards,
    PendingItemsTable,
  },
  mounted() {
    this.getFolders();
  },
  data() {
    return {
      firstRender: true,
      colors,
      truncateText: truncate,
      isEmpty,
      shortName,
    };
  },
  methods: {
    acronym(string) {
      return acronym(string);
    },
    currentUserIsOwner(currentOwner) {
      return this.user.id === currentOwner.id;
    },
    getFolders(loading = true) {
      if (loading) {
        this.$store.dispatch("toggleLoader", { show: true });
      }
      this.$store.dispatch('getFoldersPending')
        .finally(() => {
          this.$store.dispatch('toggleLoader', { show: false });
          this.$store.dispatch("setLoadingSearchText", false);
        });
      this.$store.dispatch('getFoldersCount');
    },
    goToDocument(id) {
      this.$router.push(`/pastas/${id}/show`);
    },
    capitalizeText(string) {
      return capitalize(lowerCase(string));
    },
    startCaseText(string) {
      return startCase(lowerCase(string));
    },
    formatDate(date) {
      return format(date, 'DD/MM/YYYY');
    },
    formatMonthYear(date) {
      return format(date, 'MMMM [de] YYYY', { locale: ptLocale });
    },
    truncateEntityName(entityName) {
      if (this.$vuetify.breakpoint.lgOnly) {
        return truncate(entityName, { length: 25 });
      }
      if (this.$vuetify.breakpoint.xlOnly) {
        return truncate(entityName, { length: 50 });
      }
      return truncate(entityName, { length: 15 });
    },
    orderDateToString(folder) {
      return folder.pending_date == null ? 'Sem data' : this.formatMonthYear(folder.pending_date);
    },
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    user() {
      return this.$store.getters.user;
    },
    folders() {
      let folders = this.$store.getters.folders;
      console.log('Pending Folders:', folders);
      if (folders.length === undefined) {
        return [];
      }
      folders = folders.filter(item => item.folder_section === 'pending');

      // Adicionar received_status com base no pending_type
      folders = folders.map(folder => {
        if (!folder.received_status) {
          let status = 'Não Recebido';

          // Se for uma revisão pendente ou assinatura pendente
          if (folder.pending_type === 'review') {
            status = 'Revisão';
          } else if (folder.pending_type === 'signature') {
            status = 'Assinatura';
          }

          return { ...folder, received_status: status };
        }
        return folder;
      });

      return folders;
    },
    groupedFolders() {
      console.log('Grouped Folders:', this.folders);
      const group = {};
      this.folders.forEach((folder) => {
        if (group[this.orderDateToString(folder)] == null) {
          group[this.orderDateToString(folder)] = [folder];
        } else {
          group[this.orderDateToString(folder)].push(folder);
        }
      });
      return group;
    },
  },
};
</script>

<style lang="scss" scoped>
.folder-list {
  &:last-child {
    margin-bottom: 135px;
  }
}

.custom-container {
  height: calc(100vh - 48px);
  position: relative;
  overflow: hidden;
}

.folders {
  overflow-y: auto;
  height: 100%;
  margin-top: 110px !important;
}

.list-folders-actions {
  position: absolute;
  z-index: 4;
  width: 97%;
  background: white;
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/folder/list/pending/Pending.vue